import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { FindLoad } from 'utils';
import { Loader } from 'components';
import { claimPaymentActions } from 'store';
import { ClaimPaymentInfo } from './claimPaymentDetails';
import { getRemittanceByIdClaims } from '../../../store/posting/claimPayment/claimPayment.action';

const ACTION_TYPE = 'GET_REMITTANCE_BY_ID';
export const ClaimPaymentDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        if (params?.id) {
            dispatch(claimPaymentActions.getRemittanceById(params.id));
            // dispatch(claimPaymentActions.getRemittanceDocument(params.id))
        }
    }, [params.id]);

    if (!!loader.length) return <Loader />;

    return (
        <>
            <ClaimPaymentInfo />
        </>
    );
};
